<template>
  <div>
    <footer class="dashboard-footer">
      <div class="container-cls d-flex">
        <div class="dashboard-footer-inner">
          <router-link
            class="text-link"
            :to="{ path: '/privacy-policy' }"
            target="_blank"
            >Privacy Policy</router-link
          >
          <div class="copy-right-text">
            &copy; {{ new Date().getFullYear() }}
            <a href="https://growgroupplc.com/pharma/" target="_blank"
              >Grow Pharma</a
            >
          </div>
          <router-link
            class="text-link"
            :to="{ path: '/terms&conditions' }"
            target="_blank"
            >Terms and Conditions</router-link
          >
        </div>
      </div>
    </footer>
    <div class="login-shape">
      <img
        src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1606299668242.png"
        alt
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "FrontFooter"
};
</script>
